"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeApiId = exports.getTimeNs = void 0;
const hashids_1 = __importDefault(require("hashids"));
const hashids = new hashids_1.default('', 15);
const shortIdPrefix = Math.floor(Math.random() * (0xffff + 1));
const secondsMul = BigInt(10000000);
function getTimeNs() {
    const seconds = Math.floor(Date.now() / 1000);
    const [_, nanoseconds] = typeof window === 'undefined'
        ? process.hrtime()
        : [0, Math.floor(Math.random() * (1000000000 + 1))];
    return BigInt(seconds) * secondsMul + BigInt(Math.floor(nanoseconds / 100));
}
exports.getTimeNs = getTimeNs;
function makeApiId() {
    return hashids.encode([shortIdPrefix, getTimeNs()]);
}
exports.makeApiId = makeApiId;
//# sourceMappingURL=api-id.js.map